import angular from 'angular';
import uiRouter from 'angular-ui-router';
import duScroll from 'angular-scroll';
import libraryComponent from './library.component';

let libraryModule = angular.module('library', [
  uiRouter, duScroll
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('library', {
      url: '/',
      component: 'library'
    })
    .state('library.overview', {
      url: 'overview',
    })
    .state('library.components', {
      url: 'components',
    })
    .state('library.keyScreens', {
      url: 'keyScreens',
    })
    .state('library.keyScreens.adpLogin', {
      url: '/adp-login',
    })
    .state('library.keyScreens.clientDashboard', {
      url: '/client-dashboard',
    })
    .state('library.keyScreens.clientAuthorizations', {
      url: '/client-authorizations',
    })
    .state('library.components.overallFramework', {
      url: '/overall-framework',
    })
    .state('library.components.buttons', {
      url: '/buttons',
    })
    .state('library.components.inputs', {
      url: '/inputs',
    })
    .state('library.components.tables', {
      url: '/tables',
    })
    .state('library.components.menus', {
      url: '/menus',
    })
    .state('library.components.notifications', {
      url: '/notifications',
    })
    .state('library.components.tooltips', {
      url: '/tooltips',
    })
    .state('library.components.charts', {
      url: '/charts',
    })
    .state('library.components.cards', {
      url: '/cards',
    });
})

.component('library', libraryComponent)

.name;

export default libraryModule;



// WEBPACK FOOTER //
// ./src/app/pages/library/library.js